import React, { useState } from "react";
import axios from "axios";
import { KeyRound, X } from "lucide-react";
import { toast } from "sonner";
import { formatApiError } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const input = "mt-1 w-full border-2 border-[#111] bg-white px-3 py-2 font-mono text-sm focus-ring";
const label = "font-mono text-[10px] tracking-[0.25em] uppercase text-[#555] font-bold";

function ChangePasswordModal({ onClose }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [busy, setBusy] = useState(false);
  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/auth/change-password`, { current_password: current, new_password: next }, { withCredentials: true });
      toast.success("Password updated.");
      onClose();
    } catch (err) {
      toast.error(formatApiError(err) || "Could not update password.");
    } finally {
      setBusy(false);
    }
  }
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4" style={{ background: "rgba(17,17,17,0.7)" }} data-testid="change-password-modal">
      <form onSubmit={submit} className="relative w-full max-w-sm border-2 border-[#111] bg-[#F4F3EC] p-6 space-y-4">
        <button type="button" onClick={onClose} aria-label="Close" data-testid="change-password-close" className="absolute top-3 right-3 p-1 hover:bg-[#111] hover:text-white">
          <X size={14} strokeWidth={2.6} />
        </button>
        <h2 className="font-display text-2xl font-extrabold">Change password</h2>
        <div><label className={label}>Current password</label>
          <input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} className={input} data-testid="change-password-current" /></div>
        <div><label className={label}>New password</label>
          <input type="password" required minLength={8} value={next} onChange={(e) => setNext(e.target.value)} className={input} data-testid="change-password-new" /></div>
        <button type="submit" disabled={busy} data-testid="change-password-submit" className="btn-block focus-ring w-full justify-center disabled:opacity-60">
          {busy ? "Saving…" : "Save new password"}
        </button>
      </form>
    </div>
  );
}

export default function ChangePasswordButton() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="change-password-btn"
        title="Change password"
        className="inline-flex items-center gap-1.5 font-mono text-[10px] tracking-[0.25em] uppercase font-bold border-2 border-[#111] px-3 py-1.5 hover:bg-[#111] hover:text-[#f6f6f4] transition-colors focus-ring"
      >
        <KeyRound size={11} strokeWidth={2.6} />
        Password
      </button>
      {open && <ChangePasswordModal onClose={() => setOpen(false)} />}
    </>
  );
}
